const uuidv4 = require('../util/uuidv4');

const Logger = function() {
    this.enabled = true;
    this.url = '/admin/logs/client-logs/{id}/submit';
    this.init();
};

Logger.prototype = {
    constructor: Logger,
    enabled: undefined,
    url: undefined,
    loggers: undefined,
    id: undefined,
    logs: undefined,
    baseData: undefined,
    init: function() {
        var self = this;
        if (self.enabled) {
            self.id = self.getId();
            self.baseData = {};
            self.logs = [];
            self.loggers = {
                log: console.log,
                info: console.info,
                warn: console.warn,
                error: console.error
            };
            console.log = function() {
                self.handleLog('log', arguments);
            };
            console.info = function() {
                self.handleLog('info', arguments);
            };
            console.warn = function() {
                self.handleLog('warn', arguments);
            };
            console.error = function() {
                self.handleLog('error', arguments);
            };
            self.appendIdElement(self.id);
            setInterval(function() {
                self.submitLogs();
            }, 1000);
            window.addEventListener('beforeunload popstate', function() {
                self.submitLogs();
            });

            // auto-log events

            $('body').on('click', 'button,a', function() {
                self.logButtonEvent($(this));
            });

            $('body').on('submit', 'form', function() {
                console.log('log:submit event attempt');
                var $this = $(this);
                if (!$this.attr('data-event-type')) {
                    var type = $this.attr('data-event-type') || 'click';
                    var message = $this.attr('data-event-message') || '';
                    var context = $this.attr('data-event-context') || "{}";
                    context = context ? JSON.parse(context) : {};
                    // overrides/additions
                    context.requestUri = window.location.pathname + window.location.search;
                    if ($('.dinner-form').length) {
                        context.dinnerId = $('.dinner-form').attr('data-id');
                    }
                    context.eventType = 'submit';
                    // context.buttonText = $this.text().trim();
                    if (!message) {
                        message = `Form submitted`;
                    }
                    context.cls = '.' + Array.from($this[0].classList).join('.');
                    self.log(`user:${type}`, message, context);
                }
            });

            window.addEventListener('popstate', function() {
                var context = context = {};
                // overrides/additions
                context.requestUri = window.location.pathname + window.location.search;
                if ($('.dinner-form').length) {
                    context.dinnerId = $('.dinner-form').attr('data-id');
                }
                context.eventType = 'popstate';
                self.log('user:navigation', 'Back (or Forwared) button pressed.', context);
            });

            window.addEventListener('beforeunload', () => {
                var context = context = {};
                // overrides/additions
                context.requestUri = window.location.pathname + window.location.search;
                if ($('.dinner-form').length) {
                    context.dinnerId = $('.dinner-form').attr('data-id');
                }
                context.eventType = 'beforeunload';
                self.log('user:navigation', 'Back (or Forwared) button pressed.', context);
            });
        }
    },
    logButtonEvent: function($this) {
        var self = this;
        console.log('log event attempt');
        var type = $this.attr('data-event-type') || 'click';
        var message = $this.attr('data-event-message') || '';
        var context = $this.attr('data-event-context') || "{}";
        context = context ? JSON.parse(context) : {};
        // overrides/additions
        context.requestUri = window.location.pathname + window.location.search;
        if ($('.dinner-form').length) {
            context.dinnerId = $('.dinner-form').attr('data-id');
        }
        context.eventType = 'click';
        context.buttonText = $this.text().trim().replace(/\>\s+\</, ' ');
        if (!message) {
            message = `Button '${context.buttonText}' clicked.`;
        }
        if ($this.hasClass('qty-subtract') || $this.hasClass('qty-add')) {
            context.quantity = parseInt($this.closest('.item-quantity-changes').find('h3').html());
        }
        else if ($this.hasClass('accordion-remove')) {
            var $accordionItem = $this.closest('.accordion-body-product');
            context.included = $accordionItem.attr('data-inc') === 'true' ? true : false;
            context.id = $accordionItem.attr('data-id');
            context.gid = $accordionItem.attr('data-gid');
            context.category = $accordionItem.attr('data-category');
            context.removeAll = $this.hasClass('accordion-remove-all') ? true : false;
        }
        context.cls = $this[0].classList.length ? '.' + Array.from($this[0].classList).join('.') : '';
        console.log([`user:${type}`, message, context]);
        self.log(`user:${type}`, message, context);
    },
    handleLog: function(type, args) {
        var self = this,
            date = new Date();
        self.logs.push({
            type: type,
            timestamp: date.getTime(),
            date: date,
            agent: window.navigator.userAgent,
            url: window.location.href,
            logArgs: JSON.stringify(args)
        });
        self.loggers[type].apply(null, [type.toUpperCase(), date]);
        self.loggers[type].apply(null, args);
    },
    submitLogs: function(cb) {
        var self = this,
            id = self.getId(),
            cb = cb || function() {};
        if (self.logs.length) {
            var data = Object.assign({}, self.baseData);
                data = Object.assign(data, self.logs);
            self.logs = [];
            try {
                var req = new XMLHttpRequest();
                req.open('POST', self.url.replace('{id}', id));
                req.addEventListener('readystatechange', function() {
                    if (req.readyState == 4 && req.status == 200) {
                        cb(req.responseText);
                    }
                    else if (req.status != 200) {
                        // error
                        self.loggers.error(['ERROR', new Date()]);
                        self.loggers.error('Log submission failed.', {readyState: req.readyState, status: req.status, response: req.responseText});
                    }
                });
                req.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                req.send(JSON.stringify(data));
            } catch(ex) {}
        }
        else {
            cb(null);
        }
    },
    getId: function() {
        var id = Cookies.get('luuid') ? Cookies.get('luuid') : uuidv4();
        Cookies.set('luuid', id);
        return id;
    },
    reissueId: function(cb) {
        var self = this,
            cb = cb || function() {};
        self.submitLogs(function() {
            var id = uuidv4();
            Cookies.set('luuid', id);
            cb(id);
        });
    },
    appendIdElement: function(id) {
        var elm = document.createElement('div');
        elm.style.width = 'auto';
        elm.style.position = 'fixed';
        elm.style.top = 0;
        elm.style.right = 0;
        elm.style.background = 'rgba(255, 255, 255, 0.9)';
        elm.style.color = '#555';
        elm.style.fontSize = '14px';
        elm.style.padding = '2px';
        elm.style.fontWeight = 'bold';
        elm.style.zIndex = '999999';
        elm.innerHTML = id;
        elm.classList.add('debugging-uuid');
        document.querySelector('body').append(elm);
    },
    log: function(type, message, context) {
        if (window.location.pathname.match(/\/admin/)) {
            return;
        }
        var data = Object.assign({
            type: type || null,
            message: message || null,
            context: context || {}
        });
        $.post(`/admin/logging/api/${type}`, data).then(function(response) {
            console.log(response);
        });
    }
};

var log = new Logger();
window.l = log;

module.exports = log;